const ReportTabs = {
    OVERALL: "overall",
    Calendar: "Calendar",
    Mail: "Mail",
    CHAT_DISTRIBUTIONS: "chat-distributions",
    CONTACT_DISTRIBUTIONS: "contact-distributions",
    AGENT_PERFORMANCE: "agent-performance",
    AGENT_ACTIVITIES: "agent-activities",
    AGENT_WORK_TIME: "agent-work-time",
    CUSTOMER_SATISFACTION: "customer-satisfaction",
    WEBSITE_ANALYSIS: "website-analysis",
    CHANNEL_BREAKDOWN: "channel-breakdown",
    WHATSAPP_BUSINESS_API: "whatsapp-business-api",
    Ticket: "Ticket",
    TASK: "Task",
};

export default ReportTabs;
